import React, {useContext, useState} from 'react';
import {Link, Navigate} from "react-router-dom";
import AuthenticationService from "../platform/authentication/AuthenticationService";
import UboldFullPageSignIn from "../ubold-components/UboldFullPageSignIn";
import {AuthenticationContext} from "../platform/authentication/AuthenticationContextProvider";
import {useNavigate} from "react-router";
import {createInternationalizationPrefixer} from "../platform/i18n/i18n";
import {AuthLanguageSwitcher} from "../pages/account/AuthLanguageSwitcher";

const t = createInternationalizationPrefixer("OptiselSignInPage");

export function OptiselSignInPage(props) {

    const authContextValue = useContext(AuthenticationContext);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });


    const viewStates = {
        FORM: "form",
        LOADING: "loading",
        REDIRECTING: "redirecting"
    }

    const [currentViewState, setCurrentViewState] = useState(viewStates.FORM);
    const [generalErrorMessages, setGeneralErrorMessages] = useState([]);

    const processSignIn = event => {
        setCurrentViewState(viewStates.LOADING);
        event.preventDefault();
        setGeneralErrorMessages([]);
        const passwordToBeSent = formData.password;
        setFormData({...formData, password: ""});
        AuthenticationService.signIn(formData.email, passwordToBeSent)
            .then(function () {
                console.log("Navigating to /selection");
                navigate("/selection");
            })
            .catch(function (errorMessage) {
                setCurrentViewState(viewStates.FORM);
                setGeneralErrorMessages([errorMessage]);
            });
    };

    if (authContextValue.isAuthenticated()) {
        console.log("Redirecting to / as user is authenticated");
        return <Navigate to={"/"}/>;
    }


    return <UboldFullPageSignIn
        logoImgSrc={"/img/wentech_logo.svg"}
        intro={
            [<div key={1} className="text-muted mt-3">
                <h3>Optisel 2</h3>
                Logowanie
            </div>]}
        errorMessage={(generalErrorMessages.length > 0 ? generalErrorMessages[0] : "")}
        emailLabel={"Adres e-mail"}
        emailPlaceholder={""}
        passwordLabel={"Hasło"}
        passwordPlaceholder={""}
        submitLabel={"Zaloguj"}
        copyrightVendor={"Wentech"}
        onLoginChange={v => setFormData({
            ...formData,
            email: v.target.value,
        })}
        onPasswordChange={v => setFormData({
            ...formData,
            password: v.target.value,
        })}
        loginValue={formData.email}
        passwordValue={formData.password}
        processingInProgress={currentViewState !== viewStates.FORM}
        onSubmit={processSignIn}
        additionalComponents={<>
            <div className="text-center mt-4">
                <div className="py-2">
                    <small><Link to="/register">{t("Zarejestruj się")}</Link></small>
                </div>
                <div className="py-2">
                    <small><Link to="/reset-password">{t("Nie pamiętasz hasła?")}</Link></small>
                </div>
            </div>
            <div className="mt-4"><AuthLanguageSwitcher/></div>
        </>}
    />
        ;
}

OptiselSignInPage.propTypes = {}

OptiselSignInPage.defaultProps = {}
